(function() {
  'use strict';

  directive.$inject = ["SCREENSIZE"];
  app.directive('triggerHandler', directive);

  function directive(SCREENSIZE) {
    return {
      restrict: 'A',
      scope: {
        triggerHandler: '@?'
      },
      link: link
    };

    function link(scope, el) {
      var win = angular.element(window);
      var winWidth = win.innerWidth();
      var element = angular.element(el);
      var triggerElement;

      if (winWidth < SCREENSIZE.sm) {
        element.hide();
        return;
      }

      element.on('click', function () {
        triggerElement = (scope.triggerHandler && angular.element(document.querySelector(scope.triggerHandler))) || element.next();
        triggerElement.triggerHandler('mousedown');
      });
    }
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/triggerHandler.js